<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">色卡码列表与打印</h1>
    <div class="top">
      <div class="form">
        <div class="row" :style="{ display: 'flex' }">
          <div class="item col-1" :style="{ display: 'flex' }">
            <div class="label" :style="{ lineHeight: '40px' }">品名:</div>
            <el-select
              v-model="pmname"
              filterable
              placeholder="请选择品名"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in pmlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item col-1">
            <div class="form-options">
              <el-button size="small" class="custom-btn" @click="search"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table
      :data="list"
      height="500px"
      border
      style="width: 100%"
      class="custom-table"
    >
      <el-table-column align="center" label="序号" type="index" width="50" />
      <el-table-column
        align="center"
        prop="productName"
        label="品名"
        width="140"
        show-overflow-tooltip
      />
      <el-table-column
        v-for="(shop, shopIndex) in menlist"
        :key="shop.id"
        align="center"
        min-width="160"
      >
        <template #header>
          <div class="col-header">
            <div>{{ shop.content }}</div>
            <div class="shop-name">{{ shop.name }}</div>
            <el-button
              type="primary"
              size="mini"
              class="custom-btn"
              @click="openColPrintDialog(shop, shopIndex)"
            >
              打印/下载
            </el-button>
          </div>
        </template>
        <template #default="scope">
          <el-image
            v-if="scope.row[`d${shopIndex + 1}`]"
            :src="getPreviewQrUrl(scope.row[`d${shopIndex + 1}`])"
            fit="contain"
            class="qrcode-img"
            preview-disabled
          />
          <span v-else class="empty-tip">-</span>
        </template>
      </el-table-column>
      <!-- ========== 加载更多插槽 ========== -->
      <template #append>
        <div
          class="load-more"
          :class="{ 'no-more': noMore }"
          v-if="list.length"
          @click="loadMore"
        >
          {{ noMore ? "没有数据了~" : "点击加载下一页" }}
        </div>
      </template>
    </el-table>
    <el-dialog
      v-model="colPrintDialogVisible"
      title="打印清单"
      width="600px"
      center
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="dialog-body">
        <div class="print-header">
          <div class="header-item">
            <span class="label">搜索</span>
            <el-input
              v-model="searchKeyword"
              placeholder="请输入品名"
              clearable
              @input="filterQrList"
              style="width: 200px"
            />
          </div>
          <div class="print-count-info">
            总打印数量：<span class="num" style="color: #ffae00">{{
              totalPrintNum
            }}</span>
            张
          </div>
        </div>
        <div class="shop-info">
          门店：{{ currentShopInfo.content }} {{ currentShopInfo.name }}
        </div>
        <div class="print-list">
          <div class="list-header">
            <span class="col-index">序号</span>
            <span class="col-name">品名</span>
            <span class="col-num">打印份数</span>
            <span class="col-check">
              <span class="check-cell">
                <el-checkbox
                  v-model="isAllChecked"
                  :indeterminate="isIndeterminate"
                  @change="handleCheckAllChange"
                />
              </span>
              <span class="check-label">全选</span>
            </span>
          </div>
          <div class="list-body">
            <div
              v-for="(item, idx) in filteredQrList"
              :key="idx"
              class="list-item"
            >
              <span class="item-index">{{ item.index }}</span>
              <span class="item-name">{{ item.productName }}</span>
              <!-- 份数输入框 -->
              <el-input
                v-model.number="item.printNum"
                type="number"
                min="1"
                size="small"
                class="item-num"
                @input="calcTotalNum"
              />
              <span class="item-check">
                <span class="check-cell">
                  <el-checkbox
                    v-model="selectedQrMap[idx]"
                    @change="calcTotalNum"
                  />
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="colPrintDialogVisible = false">取消</el-button>
        <el-button
          class="publish-btn"
          @click="doColPrint"
          :disabled="totalPrintNum === 0"
        >
          批量打印
        </el-button>
        <el-button
          class="publish-btn"
          @click="downloadPdf()"
          :disabled="totalPrintNum === 0"
        >
          下载二维码
        </el-button>
        <el-button
          class="publish-btn"
          @click="exportPdf"
          :disabled="totalPrintNum === 0 || pdfExporting"
          :loading="pdfExporting"
        >
          导出PDF
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, watch } from "vue";
import QRCode from "qrcode";
const { proxy } = getCurrentInstance();

const list = ref([]);
const pmname = ref("");
const pmlist = ref([]);
const menlist = ref([]);
const colPrintDialogVisible = ref(false);
const currentShopIndex = ref(0);
const currentShopInfo = ref({});
const currentShopQrList = ref([]);
const selectedQrMap = ref({});
const searchKeyword = ref("");
const filteredQrList = ref([]);
const totalPrintNum = ref(0);
const isAllChecked = ref(false);
const isIndeterminate = ref(false);
const pdfExporting = ref(false);

// 分页
const pages = ref({ page: 1, size: 50 });
const noMore = ref(false);
const loading = ref(false);

// 缓存值
const STORAGE_KEY = "/publish-clothes/colorcard/colorcardQrcodeList";

const normalizeQrData = (raw) => {
  let s = String(raw ?? "").trim();
  for (let i = 0; i < 5; i++) {
    const prev = s;
    s = s.replace(/%25/gi, "%");
    try {
      const d = decodeURIComponent(s);
      if (d !== s) s = d;
    } catch (e) {
      s = s.replace(/(?:%[0-9A-Fa-f]{2})+/g, (m) => {
        try {
          return decodeURIComponent(m);
        } catch (e2) {
          return m;
        }
      });
    }
    if (s === prev) break;
  }
  return s;
};

const makeQrDataUrl = async (rawData, width = 600) => {
  const normalized = normalizeQrData(rawData);
  const safe = normalized.replace(/%(?![0-9A-Fa-f]{2})/gi, "%25");
  return QRCode.toDataURL(safe, {
    errorCorrectionLevel: "H",
    margin: 2,
    width,
    color: { dark: "#000000", light: "#ffffff" },
  });
};

// 列表预览小图
const getPreviewQrUrl = (rawData) => {
  const normalized = normalizeQrData(rawData);
  const safe = normalized.replace(/%(?![0-9A-Fa-f]{2})/gi, "%25");
  return `https://api.qrserver.com/v1/create-qr-code/?size=70x70&ecc=H&data=${encodeURIComponent(
    safe
  )}`;
};

// 监听查询条件
watch([pmname], () => {
  const searchParams = {
    pmname: pmname.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);

      pmname.value = cache.pmname ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

const mdList = async () => {
  try {
    const res = await proxy.$api.Colorcard.get({});
    if (res.data.code == "200") {
      menlist.value = res.data.data.list;
    }
  } catch (e) {
    console.log(e);
  }
};

const pmList = async () => {
  try {
    const res = await proxy.$api.Colorcard.gets({});
    if (res.data.code == "200") {
      pmlist.value = res.data.data.list;
    }
  } catch (e) {
    console.log(e);
  }
};

// 查询
const search = () => {
  pages.value.page = 1;
  noMore.value = false;
  list.value = [];
  getList();
};

// 加载下一页
const loadMore = async () => {
  await getList(true);
};

const getList = async (isLoadMore = false) => {
  if (noMore.value || loading.value) return;
  const sendata = {
    currentPage: pages.value.page,
    pageSize: pages.value.size,
    productId: pmname.value,
  };
  try {
    loading.value = true;
    const res = await proxy.$api.Colorcard.getdy(sendata);
    if (res.data.code == 200) {
      const currentData = Array.isArray(res.data.data.list)
        ? res.data.data.list
        : [];
      // 分页拼接逻辑
      if (pages.value.page === 1) {
        list.value = currentData;
      } else {
        list.value = [...list.value, ...currentData];
      }
      // 判断是否没有更多
      const total = res.data.data.total;
      noMore.value =
        total != null
          ? list.value.length >= total
          : currentData.length < pages.value.size;
      pages.value.page += 1;
    } else if (!isLoadMore) {
      list.value = [];
    }
  } catch (e) {
    console.log(e);
    if (!isLoadMore) list.value = [];
  } finally {
    loading.value = false;
  }
};

const openColPrintDialog = async (shop, shopIndex) => {
  currentShopInfo.value = shop;
  currentShopIndex.value = shopIndex;
  const field = `d${shopIndex + 1}`;
  const rows = list.value.filter((row) => row[field]);

  //逐条生成二维码
  const qrList = [];
  let failedCount = 0;
  let index = 0;
  for (const row of rows) {
    try {
      const qrUrl = await makeQrDataUrl(row[field], 600);
      qrList.push({
        index: ++index, //序号
        productName: row.productName,
        rawData: row[field],
        qrUrl,
        printNum: 1,
      });
    } catch (e) {
      failedCount++;
      console.warn("二维码生成失败:", row.productName, e);
    }
  }
  if (failedCount > 0) {
    proxy.$message?.warning(
      `${failedCount} 条记录因内容过长生成二维码失败，已跳过`
    );
  }
  if (!qrList.length) {
    proxy.$message?.warning("该门店没有可用的二维码");
    return;
  }

  currentShopQrList.value = qrList;
  selectedQrMap.value = {};
  qrList.forEach((_, i) => {
    selectedQrMap.value[i] = false;
  });
  isAllChecked.value = false;
  isIndeterminate.value = false;
  searchKeyword.value = "";
  filteredQrList.value = [...qrList];
  calcTotalNum();
  colPrintDialogVisible.value = true;
};

const filterQrList = () => {
  if (!searchKeyword.value.trim()) {
    filteredQrList.value = [...currentShopQrList.value];
  } else {
    const keyword = searchKeyword.value.trim().toLowerCase();
    filteredQrList.value = currentShopQrList.value.filter((item) =>
      item.productName.toLowerCase().includes(keyword)
    );
  }
  calcTotalNum();
};

const handleCheckAllChange = (val) => {
  filteredQrList.value.forEach((_, idx) => {
    selectedQrMap.value[idx] = val;
  });
  isIndeterminate.value = false;
  calcTotalNum();
};

const calcTotalNum = () => {
  let total = 0;
  const filteredLen = filteredQrList.value.length;
  let checkedCount = 0;
  filteredQrList.value.forEach((item, idx) => {
    if (selectedQrMap.value[idx]) {
      checkedCount++;
      let num = Number(item.printNum) || 1;
      if (num < 1) num = 1;
      item.printNum = num;
      total += num;
    }
  });
  totalPrintNum.value = total;
  if (filteredLen === 0) {
    isAllChecked.value = false;
    isIndeterminate.value = false;
  } else {
    isAllChecked.value = checkedCount === filteredLen;
    isIndeterminate.value = checkedCount > 0 && checkedCount < filteredLen;
  }
};

// 品名可能含 & < > 等字符,写进iframe转义
const escapeHtml = (s) =>
  String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

// 打印下载PNG导出PDF公共参数
// 卡片 4cm x 3cm：顶部留白 0.3+二维码 2.1+二维码-文字间距 0.05+文字 0.25+底部留白 0.3 = 3cm
const LAYOUT_CM = {
  qrTopGapCm: 0.3, // 卡片顶部到二维码
  qrSizeCm: 2.1, // 二维码边长 2.1 x 2.1
  textGapCm: 0.05, // 二维码到文字
  textHeightCm: 0.25, // 文字高度
  nameWidthCm: 3.8, // 品名文字宽度
};

const getPrintHtml = () => {
  let printHtml = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <style>
    *{margin:0;padding:0;box-sizing:border-box;}
    @page {
      width: 8cm;
      height: 3cm;
      margin: 0;
    }
    body {
      width: 8cm;
      display: flex;
      flex-wrap: wrap;
    }
    .item{
      width: 4cm;
      height: 3cm;
      position:relative;
    }
    /* 左侧「色卡码-什么的 紧贴二维码，与二维码垂直居中 */
    .side-label{
      position:absolute;
      left: calc(50% - ${(
        LAYOUT_CM.qrSizeCm / 2 +
        LAYOUT_CM.textGapCm +
        LAYOUT_CM.textHeightCm
      ).toFixed(3)}cm);
      top:${LAYOUT_CM.qrTopGapCm}cm;
      height:${LAYOUT_CM.qrSizeCm}cm;
      width:${LAYOUT_CM.textHeightCm}cm;
      display:flex;
      flex-direction:column;
      align-items:center;
      justify-content:center;
      font-size:9.4px;
      line-height:1.05;
    }
    .side-label span{
      display:block;
    }
    /*"色卡码"三个字加粗 */
    .side-label span.b{
      font-weight:bold;
    }
    .side-label span.b:not(:nth-of-type(3)){
      margin-bottom:${(0.1).toFixed(2)}cm;
    }
    .qr-wrap{
      margin-top:${LAYOUT_CM.qrTopGapCm}cm;
      margin-left:auto;
      margin-right:auto;
      width: ${LAYOUT_CM.qrSizeCm}cm;
      height: ${LAYOUT_CM.qrSizeCm}cm;
    }
    .qr{
      width: 100%;
      height: 100%;
    }
    .text{
      /* 0.25cm ≈ 9.45px,0.3+2.1+0.05+文字+0.3=3cm,文字底边距底 0.3cm */
      font-size:9.4px;
      line-height:1;
      text-align:center;
      margin-top:${LAYOUT_CM.textGapCm}cm;
      margin-left:auto;
      margin-right:auto;
      width:${LAYOUT_CM.nameWidthCm}cm;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
  </style>
</head>
<body>
`;

  const printCtx = document.createElement("canvas").getContext("2d");
  printCtx.font = "9.4px sans-serif";
  //超宽省略号截断
  const PRINT_TEXT_MAX_PX = (LAYOUT_CM.nameWidthCm - 0.05) * (96 / 2.54);
  const shopLabel = `色卡码—${currentShopIndex.value + 1}`;
  const shopLabelHtml = [...shopLabel]
    .map((ch, i) =>
      i < 3
        ? `<span class="b">${escapeHtml(ch)}</span>`
        : `<span>${escapeHtml(ch)}</span>`
    )
    .join("");
  filteredQrList.value.forEach((item, idx) => {
    if (selectedQrMap.value[idx]) {
      let printCount = Number(item.printNum) || 1;
      for (let i = 0; i < printCount; i++) {
        const printLabel = fitEllipsis(
          printCtx,
          String(item.productName ?? ""),
          PRINT_TEXT_MAX_PX
        );
        printHtml += `
<div class="item">
  <div class="side-label">${shopLabelHtml}</div>
  <div class="qr-wrap">
    <img class="qr" src="${item.qrUrl}">
  </div>
  <div class="text">${escapeHtml(printLabel)}</div>
</div>
`;
      }
    }
  });

  printHtml += `</body></html>`;
  return printHtml;
};

const doColPrint = () => {
  const printHtml = getPrintHtml();
  colPrintDialogVisible.value = false;
  if (totalPrintNum.value === 0) return;
  let iframe = document.getElementById("printIframe");
  if (!iframe) {
    iframe = document.createElement("iframe");
    iframe.id = "printIframe";
    iframe.style.position = "absolute";
    iframe.style.left = "-9999px";
    iframe.style.top = "-9999px";
    document.body.appendChild(iframe);
  }
  const doc = iframe.contentDocument || iframe.contentWindow.document;
  doc.open();
  doc.write(printHtml);
  doc.close();
  iframe.onload = function () {
    setTimeout(() => {
      iframe.contentWindow.print();
    }, 300);
  };
};

//把选中的卡片按份数展开
const getDrawList = () => {
  const arr = [];
  filteredQrList.value.forEach((item, idx) => {
    if (!selectedQrMap.value[idx]) return;
    const count = Math.min(Number(item.printNum) || 1, 999);
    for (let i = 0; i < count; i++) {
      arr.push(item);
    }
  });
  return arr;
};

// 加载二维码图片
const loadQrImage = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("qr image load failed"));
    img.src = url;
  });

// 文字超宽时截断并加省略号
const fitEllipsis = (ctx, text, maxWidth) => {
  if (ctx.measureText(text).width <= maxWidth) return text;
  let t = text;
  while (t.length > 1 && ctx.measureText(t + "...").width > maxWidth) {
    t = t.slice(0, -1);
  }
  return t + "...";
};

const renderCardsCanvas = async (items, opts = {}) => {
  const { DPI = 300, colNum = 2, marginCm = 1, rowGapCm = 0.2 } = opts;
  const cm2px = (cm) => Math.round((cm / 2.54) * DPI);
  const cardW = cm2px(4);
  const cardH = cm2px(3);
  const marginPx = cm2px(marginCm);
  const rowGapPx = cm2px(rowGapCm);
  const qrTopPx = cm2px(LAYOUT_CM.qrTopGapCm);
  const qrSize = cm2px(LAYOUT_CM.qrSizeCm);
  const textGapPx = cm2px(LAYOUT_CM.textGapCm);
  // 文字高度 0.25cm，与打印 HTML 的 9.4px 一致
  const fontSize = Math.round(cm2px(LAYOUT_CM.textHeightCm));
  const shopLabel = `色卡码—${currentShopIndex.value + 1}`;
  const shopLabelChars = [...shopLabel];
  const rowNum = Math.ceil(items.length / colNum);
  const canvasW = cardW * colNum;
  const canvasH =
    cardH * rowNum + rowGapPx * Math.max(rowNum - 1, 0) + marginPx * 2;

  const canvas = document.createElement("canvas");
  canvas.width = canvasW;
  canvas.height = canvasH;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvasW, canvasH);

  // 先加载所有二维码，单张失败不影响
  const images = await Promise.all(
    items.map((it) => loadQrImage(it.qrUrl).catch(() => null))
  );

  images.forEach((img, i) => {
    const col = i % colNum;
    const row = Math.floor(i / colNum);
    const x = col * cardW;
    const y = row * (cardH + rowGapPx) + marginPx;
    // 二维码水平居中
    const qrX = Math.round(x + (cardW - qrSize) / 2);
    const qrY = Math.round(y + qrTopPx);
    if (img) {
      ctx.drawImage(img, qrX, qrY, qrSize, qrSize);
    }
    ctx.fillStyle = "#000000";
    ctx.font = `${fontSize}px sans-serif`;

    // "色卡码"三个字加粗，且字与字之间额外拉开
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    const charH = fontSize * 1.05;
    const boldGapPx = cm2px(0.1);
    const gapsPx = shopLabelChars.reduce(
      (acc, _, i) => acc + (i < 2 ? boldGapPx : 0),
      0
    );
    const labelTotalH = shopLabelChars.length * charH + gapsPx;
    const labelCenterX = qrX - textGapPx - fontSize / 2;
    let charY = qrY + (qrSize - labelTotalH) / 2 + charH / 2;
    shopLabelChars.forEach((ch, i) => {
      ctx.font =
        i < 3 ? `bold ${fontSize}px sans-serif` : `${fontSize}px sans-serif`;
      ctx.fillText(ch, labelCenterX, charY);
      charY += charH + (i < 2 ? boldGapPx : 0);
    });

    // 二维码下方品名（不再带 -N 后缀），宽度由 LAYOUT_CM.nameWidthCm 控制，超宽省略号截断
    ctx.textAlign = "center";
    // 以文字顶部为基线，顶部落在 0.3+2.1+0.05=2.45cm 处，文字高 0.25cm，底部留白 0.3cm
    ctx.textBaseline = "top";
    const label = fitEllipsis(
      ctx,
      String(items[i].productName ?? ""),
      cm2px(LAYOUT_CM.nameWidthCm - 0.05)
    );
    ctx.fillText(label, qrX + qrSize / 2, qrY + qrSize + textGapPx);
  });

  return canvas;
};

//下载二维码
const downloadPdf = async () => {
  if (totalPrintNum.value === 0) return;
  const drawList = getDrawList();
  if (!drawList.length) return;
  colPrintDialogVisible.value = false;
  try {
    const canvas = await renderCardsCanvas(drawList, {
      DPI: 300,
      colNum: 2,
      marginCm: 1,
      rowGapCm: 0.2,
    });
    canvas.toBlob((blob) => {
      if (!blob) {
        proxy.$message?.error("图片生成失败，请减少数量后重试");
        return;
      }
      // PNG
      const fileName = `${drawList[0].productName}-色卡码-样衣星球.png`;
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    }, "image/png");
  } catch (e) {
    console.error(e);
    proxy.$message?.error("下载失败，请稍后重试");
  }
};

//导出 PDF

const canvasToJpegBytes = (canvas, quality = 0.95) =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("canvas toBlob failed"));
          return;
        }
        blob.arrayBuffer().then((buf) => resolve(new Uint8Array(buf)));
      },
      "image/jpeg",
      quality
    );
  });

/**
 * 拼装 PDF文件
 */
const buildPdfBlob = (pageList) => {
  const enc = new TextEncoder();
  const parts = [];
  let size = 0;
  const put = (u8) => {
    parts.push(u8);
    size += u8.byteLength;
  };
  const putStr = (s) => put(enc.encode(s));

  const offsets = [];
  const objCount = pageList.length * 3 + 2;

  putStr("%PDF-1.4\n");

  const beginObj = (n) => {
    offsets[n] = size;
    putStr(`${n} 0 obj\n`);
  };

  beginObj(1);
  putStr("<< /Type /Catalog /Pages 2 0 R >>\nendobj\n");

  const kids = pageList.map((_, i) => `${3 + i * 3} 0 R`).join(" ");
  beginObj(2);
  putStr(
    `<< /Type /Pages /Kids [${kids}] /Count ${pageList.length} >>\nendobj\n`
  );

  pageList.forEach((p, i) => {
    const pageObj = 3 + i * 3;
    const contentObj = pageObj + 1;
    const imgObj = pageObj + 2;

    // 页面
    beginObj(pageObj);
    putStr(
      `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${p.pageWpt} ${p.pageHpt}] ` +
        `/Resources << /XObject << /Im0 ${imgObj} 0 R >> >> ` +
        `/Contents ${contentObj} 0 R >>\nendobj\n`
    );

    // 内容流
    const content = `q\n${p.wPt} 0 0 ${p.hPt} ${p.xPt} ${p.yPt} cm\n/Im0 Do\nQ\n`;
    beginObj(contentObj);
    putStr(
      `<< /Length ${content.length} >>\nstream\n${content}endstream\nendobj\n`
    );

    // 图片
    beginObj(imgObj);
    putStr(
      `<< /Type /XObject /Subtype /Image /Width ${p.pxW} /Height ${p.pxH} ` +
        `/ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode ` +
        `/Length ${p.jpeg.byteLength} >>\nstream\n`
    );
    put(p.jpeg);
    putStr("\nendstream\nendobj\n");
  });

  const xrefOffset = size;
  const total = objCount + 1;
  let xref = `xref\n0 ${total}\n0000000000 65535 f \n`;
  for (let n = 1; n <= objCount; n++) {
    xref += `${String(offsets[n] || 0).padStart(10, "0")} 00000 n \n`;
  }
  putStr(xref);
  putStr(
    `trailer\n<< /Size ${total} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF\n`
  );

  return new Blob(parts, { type: "application/pdf" });
};

const exportPdf = async () => {
  if (totalPrintNum.value === 0 || pdfExporting.value) return;
  const drawList = getDrawList();
  if (!drawList.length) return;

  pdfExporting.value = true;
  try {
    // 排版与下载二维码一样
    const LAYOUT = {
      DPI: 300,
      colNum: 2,
      marginCm: 1,
      rowGapCm: 0.2,
    };
    const MAX_PAGE_H_MM = 5000;
    const rowsPerPage = Math.max(
      1,
      Math.floor(
        (MAX_PAGE_H_MM - LAYOUT.marginCm * 10 * 2) / (30 + LAYOUT.rowGapCm * 10)
      )
    );
    const perPage = rowsPerPage * LAYOUT.colNum;
    const pageCount = Math.ceil(drawList.length / perPage);

    const pageList = [];
    for (let p = 0; p < pageCount; p++) {
      const chunk = drawList.slice(p * perPage, p * perPage + perPage);
      const canvas = await renderCardsCanvas(chunk, LAYOUT);
      const jpeg = await canvasToJpegBytes(canvas, 0.95);
      // 页面尺寸 = 画布物理尺寸，图片铺满整页
      const wPt = (canvas.width * 72) / LAYOUT.DPI;
      const hPt = (canvas.height * 72) / LAYOUT.DPI;
      pageList.push({
        jpeg,
        pxW: canvas.width,
        pxH: canvas.height,
        xPt: 0,
        yPt: 0,
        wPt: Number(wPt.toFixed(2)),
        hPt: Number(hPt.toFixed(2)),
        pageWpt: Number(wPt.toFixed(2)),
        pageHpt: Number(hPt.toFixed(2)),
      });
      canvas.width = 0;
      canvas.height = 0;
    }

    const blob = buildPdfBlob(pageList);
    const fileName = `${drawList[0].productName}-色卡码-样衣星球.pdf`;
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);

    proxy.$message?.success("PDF 已导出");
    colPrintDialogVisible.value = false;
  } catch (e) {
    console.error("export pdf failed", e);
    proxy.$message?.error("导出PDF失败，请稍后重试");
  } finally {
    pdfExporting.value = false;
  }
};

onMounted(() => {
  mdList();
  pmList();
  loadSearchCache();
  getList();
});
</script>

<style lang="scss" scoped>
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
.main-panel.large {
  background-color: #fff;
}
.panel-title {
  color: #666;
}
:deep(.custom-table) {
  background: #fff;
  th {
    background: #fff !important;
    white-space: pre-line;
  }
  td {
    background: #fff !important;
  }
}
.col-header {
  text-align: center;
  line-height: 1.4;
  .shop-name {
    margin: 4px 0;
  }
}
.qrcode-img {
  width: 60px;
  height: 60px;
}
.empty-tip {
  color: #999;
}
.load-more {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #666;
  cursor: pointer;
  &:hover {
    background: #e9ecef;
  }
  &.no-more {
    color: #999;
    cursor: default;
  }
}
.dialog-body {
  max-height: 60vh;
  overflow-y: auto;
}
.shop-info {
  font-weight: bold;
  margin-bottom: 12px;
}
.print-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
}
.header-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.header-item .label {
  font-size: 14px;
  color: #333;
}
.print-count-info {
  font-size: 14px;
  color: #666;
  .num {
    color: #409eff;
    font-weight: bold;
  }
}
.print-list {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.list-header {
  display: flex;
  background-color: #f5f7fa;
  padding: 10px 16px;
  font-weight: bold;
}
.col-index {
  width: 60px;
  flex: none;
  text-align: center;
}
.col-name {
  flex: 1;
}
.col-num {
  width: 110px;
  flex: none;
  text-align: center;
}
.col-check {
  width: 110px;
  flex: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.check-cell {
  width: 24px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.check-label {
  position: absolute;
  left: calc(50% + 16px);
}
.list-body {
  max-height: 40vh;
  overflow-y: auto;
}
.list-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.item-index {
  width: 60px;
  flex: none;
  text-align: center;
  color: #999;
}
.item-name {
  flex: 1;
}
.item-num {
  width: 110px;
  flex: none;
  margin: 0;
}

.item-num :deep(.el-input__inner) {
  text-align: center;
}
.item-check {
  width: 110px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style>
.publish-btn {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333 !important;
  font-weight: 500;
}
</style>
